import EtablissementPoleEmploiAdhesion from '@/generated/controls/etablissement/EtablissementPoleEmploiAdhesion.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementPoleEmploiAdhesion
})
